import { render, staticRenderFns } from "./entity-description.vue?vue&type=template&id=621c5a82"
import script from "./entity-description.vue?vue&type=script&lang=js"
export * from "./entity-description.vue?vue&type=script&lang=js"
import style0 from "./entity-description.vue?vue&type=style&index=0&id=621c5a82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports